exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-orange {\n  color: #FFAB31;\n  font-weight: 900;\n  font-size: 1rem; }\n\n.alert-center {\n  margin-left: auto;\n  margin: auto; }\n\n.link {\n  color: blue; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/juegos/components/verification/verification.scss
// module id = ../../../../../src/app/juegos/components/verification/verification.scss
// module chunks = 6